import TerritorialService from '../../services/TerritorialService'

const state = {
  territoriales: [],
  territorial: null,
  totalItems: 0,
  currentPage: 1,
  itemsPerPage: 100
}

const getters = {
  territoriales: state => state.territoriales,
  territorial: state => state.territorial,
  totalItems: state => state.totalItems,
  currentPage: state => state.currentPage,
  itemsPerPage: state => state.itemsPerPage
}

const actions = {
  async fetchTerritoriales({ commit, state }, { page = 1, filters = {} }) {
    try {
      const response = await TerritorialService.getTerritoriales(page, state.itemsPerPage, filters)
      commit('setTerritoriales', response.data.data)
      commit('setTotalItems', response.data.total || 0)
      commit('setCurrentPage', page)
      return response
    } catch (error) {
      console.error('Error fetching territoriales:', error)
      throw error
    }
  },

  async fetchTerritorial({ commit }, id) {
    try {
      const response = await TerritorialService.getTerritorial(id)
      commit('setTerritorial', response.data.data)
      return response
    } catch (error) {
      throw error
    }
  }
}

const mutations = {
  setTerritoriales(state, territoriales) {
    state.territoriales = territoriales
  },
  setTerritorial(state, territorial) {
    state.territorial = territorial
  },
  setTotalItems(state, total) {
    state.totalItems = total
  },
  setCurrentPage(state, page) {
    state.currentPage = page
  },
  setItemsPerPage(state, itemsPerPage) {
    state.itemsPerPage = itemsPerPage
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}